import type { RouteLocationNormalizedLoaded } from "vue-router";
import { AppRouteNames } from "@/app/registration-app/shared/@types/AppRouteNames";
import FbsHubRegistrationView from "@/app/registration-app/user/fbs-hub-registration/FbsHubRegistrationView/FbsHubRegistrationView.vue";
import GasShopRegistrationView from "@/app/registration-app/user/gas-shop-registration/GasShopRegistrationView/GasShopRegistrationView.vue";
import InvitedRegistrationView from "@/app/registration-app/user/invited-registration/InvitedRegistrationView/InvitedRegistrationView.vue";
import MobilityRegistrationView from "@/app/registration-app/user/mobility-registration/MobilityRegistrationView/MobilityRegistrationView.vue";
import NewRegistrationView from "@/app/registration-app/user/new-registration/NewRegistrationView/NewRegistrationView.vue";
import RegistrationOverviewView from "@/app/registration-app/user/registration-overview/RegistrationOverviewView/RegistrationOverviewView.vue";
import VerifyEmailView from "@/app/registration-app/user/verify-email/VerifyEmailView/VerifyEmailView.vue";

export const routes = [
  {
    path: "",
    name: AppRouteNames.RegistrationOverview,
    component: RegistrationOverviewView,
  },
  {
    path: "mobility",
    name: AppRouteNames.MobilityRegistration,
    component: MobilityRegistrationView,
  },
  {
    path: "new-user",
    name: AppRouteNames.NewUserRegistration,
    component: NewRegistrationView,
  },
  {
    path: "confirm",
    name: AppRouteNames.InvitedUserRegistration,
    component: InvitedRegistrationView,
    props: (route: RouteLocationNormalizedLoaded) => ({
      provisioningKey: route.query.provisioningKey,
      registrationType: route.query.registrationType,
    }),
  },
  {
    path: "verify-email",
    name: AppRouteNames.VerifyEmail,
    component: VerifyEmailView,
    props: (route: RouteLocationNormalizedLoaded) => ({
      email: route.query.email,
      token: route.query.token,
    }),
  },
  {
    path: "fbs-hub",
    name: AppRouteNames.FbsHubRegistration,
    component: FbsHubRegistrationView,
  },
  {
    path: "gas-shop",
    name: AppRouteNames.GasShopRegistration,
    component: GasShopRegistrationView,
  },
];
